export const FILTER_INPUT_COMPONENTS = [
  {
    name: 'from',
    label: 'From'
  },
  {
    name: 'to',
    label: 'To'
  },
  {
    name: 'subject',
    label: 'Subject'
  },
  {
    name: 'body',
    label: 'Body'
  }
]

export const FILTER_DATEPICKER_COMPONENTS = {
  LABEL: 'Date',
  COMPONENTS: [
    {
      name: 'dateFrom',
      placeholder: 'From...',
      isMonthPickerVisible: false
    },
    {
      name: 'dateTo',
      placeholder: 'To...',
      isMonthPickerVisible: false
    }
  ]
}

export const CHECKBOX_COMPONENTS = [
  {
    name: 'hasAttachments',
    label: 'Has Attachments'
  }
]

export const OFFSET_INCREMENT = 5
